import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export default function SimpleLayout({ children }) {
  return (
    <Box sx={{ pt: 'var(--safe-area-top)', pb: 'var(--safe-area-bottom)' }}>
      {children}
    </Box>
  );
}

SimpleLayout.propTypes = {
  children: PropTypes.node,
};
